import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVimeoComponent } from './simple-icons-vimeo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVimeoComponent ],
    exports:      [ SimpleIconsVimeoComponent ],
    bootstrap:    []
})
export class SimpleIconsVimeoModule {}
